import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import WeatherInfo from './components/WeatherInfo';
import WeatherForm from './components/WeatherForm';
import { WEATHER_KEY } from './keys'

class App extends Component {

  state = {
    dataAPI : {
      main: '',
      description: '',
      could: '',
      coordLat: '',
      coordLon: '',
      temp: '',
      tempMax: '',
      tempMin: '',
      feelLike: '',
      humidity: '',
      nameCity: '',
      pressure: '',
      country: '',
      windSpeed: '', 
      windDeg: '',
      icon: '',
      error : null      
    }
  }

  getWeather = async e => {
    e.preventDefault();
    const { city } = e.target.elements;
    const cityValue = city.value;

    if( cityValue ){
      const API_URL = `https://api.openweathermap.org/data/2.5/weather?q=${cityValue}&appid=${WEATHER_KEY}&units=metric`;
      const response = await fetch(API_URL);
      const data = await response.json();
     // console.log(API_URL);
      
      if( response.statusText === "OK" ){
        this.setState(prevState => {
          let dataAPI = Object.assign({}, prevState.dataAPI); 
          dataAPI.main = data.weather[0].main; 
          dataAPI.description = data.weather[0].description; 
          dataAPI.could = data.clouds.all;  
          dataAPI.coordLat = data.coord.lat;
          dataAPI.coordLon = data.coord.lon;
          dataAPI.temp= data.main.temp;
          dataAPI.tempMax= data.main.temp_max;
          dataAPI.tempMin= data.main.temp_min;
          dataAPI.feelLike = data.main.feels_like;
          dataAPI.humidity = data.main.humidity;
          dataAPI.pressure = data.main.pressure;
          dataAPI.nameCity = data.name;
          dataAPI.country = data.sys.country;
          dataAPI.windSpeed = data.wind.speed; 
          dataAPI.windDeg = data.wind.deg; 
          dataAPI.error = null;              
          return { dataAPI };                                
        });
        city.value = "";
      }else{
        city.value = "";
        this.setState(prevState => {
          let dataAPI = Object.assign({}, prevState.dataAPI); 
          dataAPI.error = 'Please Enter a City';
          return { dataAPI };                                
        }) 
      }
    }else{
      city.value = "";    
      this.setState(prevState => {
        let dataAPI = Object.assign({}, prevState.dataAPI); 
        dataAPI.error = 'Please Enter a City';
        return { dataAPI };                                
      })      
    }              
  }

  render(){
    return (
      <div className="App">
        <header className="App-header">
          <div className="App-header-content">
            <div className="header-logo">
              <img src={logo} className="App-logo" alt="logo" />
            </div>
            <div className="header-title">
              <h1> My App React Weather </h1>
            </div>
          </div>
        </header>
        <div className="container p-2 mx-auto">
          <div className="row mx-auto">
            <div className="col-md-10 mx-auto">
              <WeatherForm getWeather={this.getWeather} />               
            </div>
          </div>
        </div>
        <div className="col-md-10 container p-2">
          <div className="row col-md-12">
            <div className="col-md-12 mx-auto">
              <WeatherInfo Data={ this.state.dataAPI } />              
            </div>
          </div>
        </div>        
      </div>
    )
  }
}

export default App;
